import { useAsyncCallback } from 'react-async-hook';
import { useInviteStore } from '../store/use-invite-store';
import { api } from './instance';

export function useCompleteBooking() {
  const { invite, setInvite } = useInviteStore();
  return useAsyncCallback(async () => {
    await api.auth.post('onlinebooking/complete-booking', {
      json: {
        bookingReference: invite.reference,
      },
      retry: {
        limit: 100,
        backoffLimit: 10000,
      },
    });
    // TODO: FIX ME
    setInvite({ ...invite, status: 'Completed' });
  });
}
